// @flow

import { type PendingIncomingPayment } from './types';

export function getSafeVoucherUrl(incomingPayment: PendingIncomingPayment): string {
  const voucherUrl = incomingPayment['voucher_url'];
  if (!voucherUrl)
    throw new Error('Voucher: Invalid state - There is no voucher_url property for this payment');

  return voucherUrl;
}
